__turbopack_context__.v({
  "close": "SharpnessCloseButton-module-scss-module__0ExU1q__close",
  "fade-in": "SharpnessCloseButton-module-scss-module__0ExU1q__fade-in",
  "headerHidden": "SharpnessCloseButton-module-scss-module__0ExU1q__headerHidden",
  "inner": "SharpnessCloseButton-module-scss-module__0ExU1q__inner",
  "isOverlay": "SharpnessCloseButton-module-scss-module__0ExU1q__isOverlay",
  "portalInner": "SharpnessCloseButton-module-scss-module__0ExU1q__portalInner",
  "root": "SharpnessCloseButton-module-scss-module__0ExU1q__root",
});
